/**
 * config.js — Konfigurasi terpusat untuk seluruh aplikasi Frontend.
 */
const API_URL = "https://api.jogjavilla.id";

export default API_URL;